import React from 'react';
import cx from 'classnames';
import styles from './menu.css';
import { MainLink, SecondaryLink, Menu as Root } from './styled';
/* eslint-disable react/prop-types */

class Menu extends React.Component {
  render() {
    const { className, open, data } = this.props;

    const mainLinks = data.items.filter(item => parseInt(item.main, 10));
    const secondaryLinks = data.items.filter(item => !parseInt(item.main, 10));

    return (
      <Root bgColor={data.colors.background} background={data.background} className={cx(styles.root, className, !open && styles.closing)}>
        <nav className={styles.navigation}>
          <div className={styles.mainLinks}>
            {mainLinks.map(link => (
              <li key={link.url} className={styles.mainListItem}>
                <MainLink className={styles.mainLink} colors={link.colors} to={link.url}>
                  {link.title}
                </MainLink>
              </li>
            ))}
          </div>
          <div className={styles.secondaryLinks}>
            {secondaryLinks.map(link => (
              <li key={link.url} className={styles.secondaryListItem}>
                <SecondaryLink colors={link.colors} to={link.url} className={styles.secondaryLink}>
                  {link.title}
                </SecondaryLink>
              </li>
            ))}
          </div>
        </nav>
      </Root>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/modules/Menu/Menu.js